import * as React from "react";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { LocaleContext } from "@/contexts/useLocale";

export const LocaleProvider = ({ children }: { children: React.ReactNode }) => {
  const user = useAuthenticatedUser();

  const value = React.useMemo(
    () => ({
      dateFormat: user.dateFormat,
      timeFormat: user.timeFormat,
    }),
    [user.dateFormat, user.timeFormat],
  );

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};
